// tslint:disable: max-classes-per-file
import { IFunds } from '@models/fund.class';
import { Action } from '@ngrx/store';

export enum FundActionTypes {
  REQUEST_FUNDS = '[Funds] Request funds',
  FUNDS_RECEIVED = '[Funds] Funds received',
  FUNDS_NOT_RECEIVED = '[Funds] Funds not received',
  SELECT_FUND = '[Funds] Select Fund',
}

export class RequestFunds implements Action {
  readonly type = FundActionTypes.REQUEST_FUNDS;

  constructor(public payload?: any) {}
}

export class FundsReceived implements Action {
  readonly type = FundActionTypes.FUNDS_RECEIVED;

  constructor(public payload: IFunds) {}
}

export class FundsNotReceived implements Action {
  readonly type = FundActionTypes.FUNDS_NOT_RECEIVED;

  constructor(public payload: string) {}
}

export class SelectFund implements Action {
  readonly type = FundActionTypes.SELECT_FUND;

  constructor(public payload?: { issueID: string; valueType: number }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type FundsActionsUnion =
  | RequestFunds
  | FundsReceived
  | FundsNotReceived
  | SelectFund;
